'use client';

// base
import React, { useEffect } from 'react';

// styles
import { StyledSwiper } from './style';
// import 'swiper/css';

// // components
// import { LazyImageV2 } from 'components';

// libraries
import SwiperCore from 'swiper';
import Paper from '@mui/material/Paper';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Autoplay, Pagination } from 'swiper/modules';

// interface ImageSwiperListProps {
//   fileUrl: string;
//   id: string;
// }

interface ImageSwiperListProps {
  file: File;
  id: string;
}

interface ImageSwiperProps {
  imageList: ImageSwiperListProps[];
  isAuto?: boolean;
}

export const ImageSwiper: React.FC<ImageSwiperProps> = ({ imageList, isAuto = true }) => {
  return (
    <StyledSwiper>
      <Swiper
        loop
        navigation
        slidesPerView={1}
        modules={[Navigation, Autoplay, Pagination]}
        pagination={{ type: 'bullets', clickable: true }}
        autoplay={isAuto ? { delay: 3000, disableOnInteraction: false } : false}
      >
        {imageList.map((item, i) => (
          <SwiperSlide key={item.id}>
            <img
              src={URL.createObjectURL(item.file)}
              alt={`${i + 1}번 슬라이드`}
              style={{ width: '100%', height: '300px', objectFit: 'cover' }}
            />
          </SwiperSlide>
        ))}
      </Swiper>
    </StyledSwiper>
  );
};
